import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Components
import { Button, Col } from 'components';
import { AppleLogin, FbLogin, GgLogin } from 'screens/Login/components';

// Utils
import { theme } from 'lib';

const SignupWithSocials = ({
  isMobile,
  handleLoadingSocialSignIn,
  onHandleSignUpWithEmail,
  followUpDetails,
  redirectUrl
}) => {
  const { t } = useTranslation();

  return (
    <Col centerAll wid="100%">
      <Col
        start
        center
        centerAll
        pos={'relative'}
        pad={'12px 0 0'}
        noFlex
        bg="#fff"
        enableMediaQuery
        wid="288px"
      >
        <FbLogin
          handleLoadingSocialSignIn={handleLoadingSocialSignIn}
          redirectUrl={redirectUrl}
          CustomButton={(props) => (
            <Button
              pos="relative"
              facebook
              onClick={props.onClick}
              marg="16px 0 0"
              text={'Continue'}
            />
          )}
          isSignup
        />

        <GgLogin
          handleLoadingSocialSignIn={handleLoadingSocialSignIn}
          CustomButton={(props) => (
            <Button google onClick={props.onClick} marg="16px 0 0" text={'Continue'} />
          )}
          isSignup
          followUpDetails={followUpDetails}
          redirectUrl={redirectUrl}
        />

        <AppleLogin
          followUpDetails={followUpDetails}
          redirectUrl={redirectUrl}
          CustomButton={(props) => (
            <Button apple onClick={props.onClick} marg="16px 0 0" text={'Continue'} />
          )}
        />

        <TextDivider>{t('common.or')}</TextDivider>

        <Button
          wid="100%"
          text={t('common.signUp')}
          bg={theme.SECONDARY}
          app
          onClick={onHandleSignUpWithEmail}
          action="signUp"
        />
      </Col>
    </Col>
  );
};

const TextDivider = styled.p`
  position: relative;
  margin: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: lowercase;

  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    background-color: #ccc;
    width: 40%;
    height: 1px;
  }
  &::after {
    position: absolute;
    content: '';
    right: 0;
    top: 50%;
    background-color: #ccc;
    width: 40%;
    height: 1px;
  }
`;

export default SignupWithSocials;
